module.exports = __webpack_public_path__ + "img/file.05555d18.png";